<template>
  <div class="container">
    <p class="title">《隐私声明》</p>
    <p><strong>强生（上海）医疗器材有限公司</strong>（“我们”或“公司”）尊重您的隐私，并向您告知我们如何收集、使用、存储和保护（“处理”）您的个人信息。本隐私声明描述了我们或我们的服务提供商如何通过我们控制和运营的星光直播平台及其他向您提供星光直播相关服务的线上或线下渠道（如线上调研或线下拜访）（以下合称“本服务”）处理个人信息的相关实践。请您注意，如前述线上或线下渠道有单独的个人信息处理规则，并且该单独的个人信息处理规则对本隐私声明中内容有另行约定的，则以该单独的个人信息处理规则中的相关内容为准；该单独的个人信息处理规则中未涵盖的内容，应以本隐私声明为准。处理个人信息。</p>
    <p>在使用本服务或向我们提供个人信息之前，请仔细阅读本隐私声明。</p><br/>

    <h3>一、未成年人使用</h3>
    <p>本服务并非面向十八（18）周岁以下的个人，我们请求上述个人不要通过本服务提供个人信息。如果您的子女已经提交了个人信息，而您希望删除该等个人信息，请按照下文“联系我们”部分提供的联系方式与我们联系。</p><br/>

    <h3>二、个人信息的收集</h3>
    <p>当您使用本服务时，我们会基于以下目的，处理您的个人信息：</p>
    <ul class="ul">
      <li>为了帮助您完成注册，验证您的身份（包括通过您提供的手机号码向您发送身份验证结果），保护您的账号安全，与您就本服务相关活动通过线上或线下渠道进行沟通并收集您对本服务的反馈：您的姓名、手机号码、所在省市、医院、一级科室、二级科室、职称、医师执业资格证书编码/编号、工牌/工作证照片（若您的工牌/工作证照片中，包含您的个人照片/面部肖像，请您在提供工牌/工作证照片前，对个人照片/面部肖像进行遮挡或移除。我们在本服务中，不会收集您的个人照片/面部肖像）；</li>
      <li>为了向您提供您所在专业领域相关学术内容，向您提供专业教育服务，以及进行数据分析：您的行为数据（比如浏览时长、浏览内容）、您对本服务的反馈；</li>
      <li>为了维护发展与您的合作关系，通过线上交流或日常拜访的形式与您进行专业教育相关的沟通和交流，收集您对本服务的反馈：上述您的全部个人信息。</li>
    </ul>
    <p>您也可以通过阅读我们的《个人信息收集清单》，了解您的个人信息收集情况。</p>
    <p>如果您向我们提交任何有关其他个人的个人信息，代表您确认，您已取得该个人的个人同意或其他处理个人信息的合法性基础，向我们提供个人信息的行为不存在任何违反可适用的法律法规、部门规章、国家或行业标准的情况。</p><br/>

    <h3>三、敏感个人信息</h3>
    <p>除非我们特别要求或请求，否则请勿在本服务提供过程中或通过本服务或其他方式向我们发送或披露任何敏感个人信息，即一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息（例如生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息）。</p><br/>

    <h3>四、个人信息委托处理、共享及转让</h3>
    <p>我们所处理的您的个人信息，仅可能由以下法律实体或人员在必要知道或法律要求的情况下访问。我们会根据具体情况，履行相关法律法规所规定的义务，包括在法律法规要求时，取得您的同意：</p>
    <p>1.为了向您提供服务，我们可能会委托第三方服务供应商处理您的部分个人信息，我们会在符合法律法规规定的情形下委托其处理您的个人信息。对于我们委托其处理个人信息的公司、组织和个人（如有），我们会与其签署严格的保密协议或保密条款，要求其按照我们的要求以及本隐私声明及同等标准的要求和安全措施来处理个人信息。</p>
    <p>2.为了符合法律法规的要求，我们可能会向相关主管部门提供您的个人信息。</p>
    <p>3.在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的组织继续受本隐私声明的约束，或要求其向您征得新的授权同意。</p>
    <p>除上述情况外，我们不会向其他第三方提供您的个人信息。</p><br/>

    <h3>五、您如何行使您的个人信息主体权利</h3>
    <p>按照适用的法律法规，您享有《个人信息保护法》等法律法规下的个人信息主体权利。如果您希望行使您依法享有的查阅、复制、转移、更正、补充、删除、限制处理个人信息以及注销账号、撤回同意等个人信息主体权利，请按照下文“联系我们”部分中提供的联系方式与我们联系。我们将在合理可行的情况下尽快且不迟于收到您的请求后十五（15）个工作日内予以答复。如果存在特殊情况导致我们延迟回复，我们将及时通知您，并提供我们回复的日期。</p>
    <p>除了上述权利外，您亦有权向相关个人信息保护主管机构投诉。</p><br/>

    <h3>六、个人信息安全</h3>
    <p>我们严格遵守相关的法律法规，并采取全面的个人信息保护措施。我们已建立专门的数据安全管理部门，依据数据分类与分级规范，围绕数据的整个生命周期，制定并落实相应的管理制度和技术措施。具体措施包括：</p>
    <ul class="ul">
      <li>我们的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户个人信息在传输过程中的安全；</li>
      <li>根据数据分类与分级，采取相应的加密措施进行数据保存，并使用隔离技术进行安全隔离；定期对安全边界的网络设备进行安全评估和审核，及时修补漏洞，杜绝弱口令；定期进行系统和代码级别的漏洞扫描，及时修补发现的安全漏洞及配置不符合项；</li>
      <li>我们制定了严格的数据使用和访问制度，采用严格的数据访问权限控制保护个人信息，避免您的个人信息被违规使用；</li>
      <li>采取了数据和技术安全审计，建立日志审计和行为审计机制，确保流程的安全可控；</li>
      <li>我们还定期举办安全和隐私保护培训课程，不断加强员工对于保护个人信息重要性的认识；</li>
      <li>此外，我们设立了专门的部门，负责安全应急响应和个人信息安全保障工作，确保在突发事件时能够快速有效地应对和处置。</li>
    </ul>
    <p>如果您发现您的个人信息可能或已经泄露或处于不安全的状态，请立即按照下文“联系我们”部分中提供的联系方式与我们联系，以便我们采取合适的措施避免或减轻相关损失。 我们将持续完善安全体系，切实保障您的个人信息安全。目前，我们的重要信息系统都已经通过网络安全等级保护的测评要求。</p><br/>

    <h3>七、个人信息的存储与删除</h3>
    <p>我们将根据收集您的个人信息时所述的目的，在需要或允许的最短的期限内保留您的个人信息。用于确定我们保留期限的标准包括：（i）我们与您保持持续关系并向您提供服务的时间长度；（ii）是否存在约束我们的法律义务；以及（iii）根据我们的法律地位（例如适用的诉讼时效、诉讼或监管调查）。</p>
    <p>在必要的保留时间后，除非法律、行政法规另有规定或您同意继续保留信息，我们将删除或匿名化处理您的个人信息。如删除或匿名化在技术上难以实现的，我们将停止除存储和采取必要的安全保护措施之外的处理。</p>
    <p>我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</p><br/>
    
    <h3>八、联系我们</h3>
    <p>强生（上海）医疗器材有限公司位于上海市徐汇区桂箐路65号新研大厦A座，是本隐私声明项下的个人信息处理者。</p>
    <p>如果您对本隐私声明有任何疑问，或希望行使您作为个人信息主体的合法权利，您可以发送邮件至Chinaprivacy@its.jnj.com联系我们。</p>
    <p>您也可以通过以下链接向我们提交您的权利请求：</p>
    <p><a href="https://privacyportal.onetrust.com/webform/96f23ee1-34e3-41d6-8d5a-07f0d554152b/3034f16e-7700-486e-98c2-b2cbb05f4cd3?ApplicationName=XingGuangZhiBo">https://privacyportal.onetrust.com/webform/96f23ee1-34e3-41d6-8d5a-07f0d554152b/3034f16e-7700-486e-98c2-b2cbb05f4cd3?ApplicationName=XingGuangZhiBo</a></p><br/>

    <h3>九、对本隐私声明的更新</h3>
    <p>我们可能会不时对本隐私声明进行修订，当本隐私声明重新修订后，我们会以推送通知或弹窗或其他符合法律要求的适当形式向您展示修订后的隐私声明。</p>
    <p>请您注意，只有在您确认修订后的隐私声明后，我们才会按照修订后的隐私声明处理您的个人信息；您可以选择不同意修订后的隐私声明，但可能导致您无法使用部分服务及功能。</p>
    <p>本隐私声明的更新不会削减您应享有的合法权利。</p>

    <p style="text-align: right;">【2025年9月】</p><br/><br/>

    
    <p class="title">附录：个人信息收集清单</p><br/>

    <!-- <p class="subtitle">一、个人信息收集清单</p><br/> -->
    <div class="table1">
      <div class="tr">
        <div class="td td1">使用场景</div>
        <div class="td td2">个人信息字段</div>
        <div class="td td3">使用目的</div>
      </div>
      <div class="tr">
        <div class="td td1">用户注册、验证用户身份（包括通过您提供的手机号码向您发送身份验证结果）和保护用户账号安全、日常拜访和用户沟通</div>
        <div class="td td2">姓名、手机号码、所在省市、医院、一级科室、二级科室、职称、医师执业资格证书编码/编号、工牌/工作证照片（若您的工牌/工作证照片中，包含您的个人照片/面部肖像，请您在提供工牌/工作证照片前，对个人照片/面部肖像进行遮挡或移除。我们在本服务中，不会收集您的个人照片/面部肖像）</div>
        <div class="td td3">帮助用户完成注册，验证用户身份，保护用户账号安全，与用户就本服务相关活动通过线上或线下渠道进行沟通并收集用户对本服务的反馈；日常拜访和用户沟通。</div>
      </div>
      <div class="tr">
        <div class="td td1">向用户提供专业教育服务、日常拜访和用户沟通</div>
        <div class="td td2">行为数据（比如浏览时长、浏览内容）、对本服务的反馈</div>
        <div class="td td3">向用户提供其所在专业领域相关学术内容和专业教育服务，并开展数据分析；日常拜访和用户沟通。</div>
      </div>
    </div><br/>

    <!-- <p class="subtitle">二、第三方信息共享清单</p>
    <div class="table2">
      <div class="tr">
        <div class="td td1">使用场景</div>
        <div class="td td2">使用目的</div>
        <div class="td td3">共享个人信息字段</div>
        <div class="td td4">共享方式</div>
        <div class="td td5">接收个人信息的第三方主体类型</div>
      </div>
      <div class="tr">
        <div class="td td1">隐私声明所述场景</div>
        <div class="td td2">隐私声明所述目的</div>
        <div class="td td3">隐私声明所列举的个人信息字段</div>
        <div class="td td4">内部数据共享</div>
        <div class="td td5">强生关联方</div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100%;
  font-size: 12px;
  padding: 12px;
  box-sizing: border-box;
  background-color: #F8F8F8;
  padding-bottom: 50px;
  .title {
    font-size: 15px;
    text-align: center;
    font-weight: bold;
  }
  .subtitle {
    font-size: 14px;
    font-weight: bold;
  }
  p {
    line-height: 2;
  }
  .ul {
    list-style-type: disc;
    margin-left: 30px;
    li {
      line-height: 2;
    }
  }
  .child_ul {
    list-style-type: circle;
    margin-left: 14px;
    li {
      line-height: 2;
    }
  }
  a {
    color: #1989fa;
  }
  .table1 {
    border: 1px solid #000000;
    .tr {
      display: flex;
      .td { 
        padding: 8px 5px;
      }
      .td1 {
        width: 30%;
        border-right: 1px solid #000000;
      }
      .td2 {
        width: 40%;
        border-right: 1px solid #000000;
      }
      .td3 {
        width: 30%;
      }
    }
    .tr:not(:last-of-type) {
      border-bottom: 1px solid #000000;
    }
    .tr:first-of-type {
      background-color: #dddddd;
    }
  }
  .table2 {
    border: 1px solid #000000;
    .tr {
      display: flex;
      .td { 
        padding: 8px 5px;
      }
      .td1 {
        width: 15%;
        border-right: 1px solid #000000;
      }
      .td2 {
        width: 20%;
        border-right: 1px solid #000000;
      }
      .td3 {
        width: 20%;
        border-right: 1px solid #000000;
      }
      .td4 {
        width: 15%;
        border-right: 1px solid #000000;
      }
      .td5 {
        width: 30%;
      }
    }
    .tr:not(:last-of-type) {
      border-bottom: 1px solid #000000;
    }
    .tr:first-of-type {
      background-color: #dddddd;
    }
  }
}
</style>